import script from "./ShippingMethodForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ShippingMethodForm.vue?vue&type=script&setup=true&lang=js"

import "./ShippingMethodForm.vue?vue&type=style&index=0&id=88369d76&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-88369d76"]])

export default __exports__